module.exports = __webpack_public_path__ + "img/info3.0b116b54.png";